import { ApiService } from "./ApiService"

export class TicketService {

    static uri = '/ticket';

    static get({ params }) {
        return ApiService.get(`${this.uri}`, {
            params,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static show({ ticketID }) {
        return ApiService.get(`${this.uri}/show/${ticketID}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static create({ data }) {
        return ApiService.post(`${this.uri}/create`, data, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static update({ data, id }) {
        return ApiService.put(`${this.uri}/update/${id}`, data, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static delete({ id }) {
        return ApiService.delete(`${this.uri}/delete/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }
}